import { axiosInstance } from '../../utils';
import { Avatar } from '../../@types';

export const fetchPublicAvatars = async (): Promise<Avatar[]> => {
  const res = await axiosInstance.get('/api/avatars/get-public-avatars');
  return res.data;
};
